module.exports = __webpack_public_path__ + "static/media/icon-github.76ef9240.svg";